import React from 'react';

import { Typography } from '@occc/ui-design-system';

export const RequiresVoucher: React.FC = () => {
  return (
    <>
      <Typography variant='body2'>Requires Voucher</Typography>
      <Typography>Yes</Typography>
    </>
  );
};
